import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './common/stylus/reset.css'
import './common/stylus/base.styl'
import axios from 'axios'
import VueAxios from 'vue-axios'
import './common/icon/iconfont.css'
import tools from '../src/utils/tools'
import VueI18n from 'vue-i18n'
import { Field, RadioGroup, Radio, Button } from 'vant';
import 'vant/lib/toast/style'
import 'vant/lib/field/style'
import 'vant/lib/radio-group/style'
import 'vant/lib/radio/style'
import 'vant/lib/button/style'
// import eruda from "eruda"
Vue.prototype.$axios = axios
// eruda.init();
// 本地接口测试
axios.defaults.baseURL = process.env.NODE_ENV == "development" ? 'http://32.wowoxi.com:8888/project/vivasing_h5/pay/dist/pay' : ''


Vue.use(VueI18n)
Vue.use(VueAxios, axios)
Vue.use(Field)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(Button)
Vue.config.productionTip = false

//多語言實例
let name = tools.getParams('lang') || 'vi';
function getLang () {
  return axios.get(`lang/${name}.json?setTime=${new Date().getTime()}`)
}

async function init () {
  let json = await getLang()
  const i18n = new VueI18n({
    locale: 'language',
    messages: {
      language: json.data
    }
  })

  new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
  }).$mount('#app')
}
init()


